import imageurls from 'commons/image-urls.json';
import addDomainToPath from 'commons/addDomainToPath';

import collectionsData from './collectionsData';
import { collectionOrder } from './collectionOrder';

const getModularCollectionImage = collectionName =>
  addDomainToPath(`${imageurls.modularCollectionsPath}${collectionName}.png`);

// Temporary method to fill missing collection information with static data
// Will be removed once API returned data is complete
export const prepareCollectionData = collectionQueryData => {
  if (!collectionQueryData) return [];

  const finalData = collectionQueryData
    .map(collection => {
      const collectionName = collection.name.split(' Modular')[0];
      if (!collection.totalProductsCount) return null;
      return {
        id: collection.id,
        name: collectionName,
        description:
          collectionsData[collectionName.toLowerCase()]?.description ||
          collection.additional_attributes.showpiece_desc ||
          '',
        image:
          collectionsData[collectionName.toLowerCase()]?.image ||
          getModularCollectionImage(collectionName),
        link: collection.modularCollectionSlug,
        productLink: collection.slug,
        products: collection.products,
        thumbnail: collectionsData[collectionName.toLowerCase()]?.thumbnail,
      };
    })
    .filter(v => !!v);
  return finalData.sort(
    (a, b) => collectionOrder.indexOf(a.name) - collectionOrder.indexOf(b.name)
  );
};

export const prepareCollectionDataStatic = collectionQueryData => {
  if (!collectionQueryData) return [];

  const finalData = collectionQueryData
    .map(collection => {
      const collectionName = collection.primaryProduct.name.split(
        ' Modular'
      )[0];
      if (!collection.products.length === 0) return null;
      return {
        id: collection.primaryProduct.id,
        name: collectionName,
        description:
          collectionsData[collectionName.toLowerCase()]?.description ||
          collection.additionalAttributes.showpiece_desc ||
          '',
        image:
          collectionsData[collectionName.toLowerCase()]?.image ||
          getModularCollectionImage(collectionName),
        link: collection.modularCollectionSlug,
        productLink: collection.primaryProduct.slug,
        products: collection.products,
        thumbnail: collectionsData[collectionName.toLowerCase()]?.thumbnail,
      };
    })
    .filter(v => !!v);
  const sortedData = finalData.sort(
    (a, b) => collectionOrder.indexOf(a.name) - collectionOrder.indexOf(b.name)
  );
  return sortedData;
};

export const getFinalBundleProducts = ({ products, parentId }) => {
  const bundleProductsTemp = [];
  const bundleProductIds = [parentId];

  products.forEach(prod => {
    const { options } = prod;
    bundleProductIds.push(prod.id);
    if (options) {
      const orientationOptions = options.filter(optionValue => {
        if (optionValue.name.toLowerCase().includes('orientation')) {
          return true;
        }
        return false;
      });
      const orientationProps = {};
      const orientationOpt = orientationOptions.length
        ? orientationOptions[0]
        : null;
      // find the left and right if present and add product for only a single orientation
      if (orientationOpt) {
        const firstOpt = orientationOpt.values[0].option_values[0];
        orientationProps.option_id = orientationOpt.id;
        // take first option in the option_values list and add to bundleProds
        // wrangle data and store in all combinations needed .
        orientationProps.currentSelection = {
          id: firstOpt.id,
          value: firstOpt.value,
          sku: firstOpt.sku,
        };
        orientationProps.option = firstOpt;
        bundleProductsTemp.push({
          ...prod,
          orientation: orientationProps,
        });
      } else {
        bundleProductsTemp.push({ ...prod, orientation: {} });
      }
    } else {
      bundleProductsTemp.push({ ...prod, orientation: {} });
    }
  });
  return { bundleProducts: bundleProductsTemp, bundleProductIds };
};
